import React from 'react';
import { FadeIn } from './FadeIn';
import { Sparkles, Check, Briefcase, ShoppingCart, TrendingUp, Clock, GraduationCap, Heart } from 'lucide-react';
export function PorQueAmazon() {
  const benefits = [{
    icon: Briefcase,
    text: 'Desarrolla una habilidad digital real'
  }, {
    icon: ShoppingCart,
    text: 'Aprende Ecommerce desde casa'
  }, {
    icon: TrendingUp,
    text: 'Descubre nuevas oportunidades de ingresos online'
  }, {
    icon: Clock,
    text: 'Aprende a tu propio ritmo'
  }, {
    icon: GraduationCap,
    text: 'Diseñado para principiantes'
  }, {
    icon: Heart,
    text: 'No necesitas experiencia previa para comenzar'
  }];
  return <section className="bg-brand-beige py-20 md:py-28 px-5 sm:px-6 relative overflow-hidden" data-id="element-416">
      {/* Subtle background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-40" data-id="element-417">
        <div className="absolute -top-32 right-0 w-[500px] h-[500px] bg-brand-gold/8 rounded-full blur-3xl" data-id="element-418"></div>
        <div className="absolute -bottom-32 left-0 w-[500px] h-[500px] bg-brand-green/5 rounded-full blur-3xl" data-id="element-419"></div>
      </div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-420">
        {/* Header */}
        <FadeIn data-id="element-421">
          <div className="text-center mb-12 md:mb-14 max-w-3xl mx-auto" data-id="element-422">
            <div className="inline-flex items-center justify-center gap-2 bg-brand-green text-white border border-brand-gold/40 rounded-full px-5 py-2 mb-6 shadow-md" data-id="element-423">
              <Sparkles className="w-3.5 h-3.5 text-brand-gold" data-id="element-424" />
              <span className="text-[11px] sm:text-xs font-bold tracking-[0.18em] uppercase text-brand-gold" data-id="element-425">
                Nueva economía digital
              </span>
            </div>
            <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl font-bold text-brand-green leading-[1.05] tracking-tight mb-6" data-id="element-426">
              ¿Por qué cada vez más personas están aprendiendo{' '}
              <span className="text-brand-gold" data-id="element-427">Amazon</span>?
            </h2>
            <p className="text-base md:text-lg text-brand-text/75 leading-relaxed mb-3" data-id="element-428">
              Cada vez más personas están desarrollando nuevas habilidades
              digitales para adaptarse a la economía actual y descubrir nuevas
              oportunidades de ingresos online desde casa.
            </p>
            <p className="text-base md:text-lg text-brand-text/65 leading-relaxed" data-id="element-429">
              Este sistema fue diseñado para ayudarte a comenzar paso a paso —
              incluso si hoy partes desde cero y no tienes experiencia previa en
              Ecommerce.
            </p>
          </div>
        </FadeIn>

        {/* Benefits card */}
        <FadeIn delay={0.15} data-id="element-430">
          <div className="bg-white border border-brand-text/8 rounded-3xl p-7 md:p-10 shadow-[0_10px_40px_-15px_rgba(0,0,0,0.1)]" data-id="element-431">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6" data-id="element-432">
              {benefits.map((b, i) => {
              const Icon = b.icon;
              return <div key={i} className="flex items-start gap-3" data-id="element-433">
                    <span className="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-brand-green/8 border border-brand-green/10 flex-shrink-0" data-id="element-434">
                      <Icon className="w-5 h-5 text-brand-green" strokeWidth={2} data-id="element-435" />
                    </span>
                    <div className="flex items-start gap-2 mt-1.5" data-id="element-436">
                      <Check className="w-4 h-4 text-brand-gold flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-437" />
                      <span className="text-sm md:text-[15px] font-semibold text-brand-text leading-snug" data-id="element-438">
                        {b.text}
                      </span>
                    </div>
                  </div>;
            })}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}